import { inject, Injectable } from '@angular/core';
import { isUndefined } from 'lodash';
import Rollbar from 'rollbar';
import { environment } from '../../../environments/environment';
import releaseSha from '../../release-sha.json';
import { BrowserControlService } from '../misc-services/browser-control.service';

@Injectable({ providedIn: 'root' })
export class RollbarService extends Rollbar {
  constructor() {
    const browserService = inject(BrowserControlService);
    super({
      enabled: environment.shouldSendErrorsToRollbar,
      maxRetries: 60,
      retryInterval: 10000,
      timeout: 30000,
      accessToken: '93465dfd128e4b539ed65f737af03abe',
      captureUncaught: true,
      ignoredMessages: [
        'Error loading script',
        "Uncaught TypeError: Cannot read property 'call' of undefined",
      ],
      filterTelemetry,
      payload: {
        environment: browserService.isCurrentHostPrototype()
          ? 'prototype'
          : environment.name,
        client: {
          javascript: {
            source_map_enabled: true,
            code_version: releaseSha.sha,
            // Have Rollbar guess which frames the error was thrown from when
            // the browser does not provide line and column numbers.
            guess_uncaught_frames: true,
          },
        },
      },

      // destroys stack trace info otherwise embedded in the error's message
      inspectAnonymousErrors: false,
    });
  }
}

function filterTelemetry(event: Rollbar.TelemetryEvent) {
  return (
    event.type === 'network' &&
    (event.body.subtype === 'xhr' || event.body.subtype === 'fetch') &&
    typeof event.body.url === 'string' &&
    event.body.url.startsWith('https://api.segment.io/')
  );
}

export function isLogArgument(arg: unknown): arg is Rollbar.LogArgument {
  return (
    isUndefined(arg) ||
    typeof arg === 'string' ||
    typeof arg === 'object' ||
    typeof arg === 'function'
  );
}
